import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'

function mapStateToProps(state) {
  return {
    locale: state.lang.locale,
    messages: state.lang.messages
  }
}

export default connect(mapStateToProps)(IntlProvider)